/// <reference path="../../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import * as CaseDocumentsActions from '../../actions/case-documents.actions';
import * as UIActions from '../../actions/ui';
import { setActiveProcess } from '../../actions/json-view';
import { decorateNotes } from '../cases.reducer';
import { logout } from '../../actions/ui';
import { jumpContext } from '../../actions/contexts.action';
export const InitialState = {
    activeCase: {},
    activeCaseRun: {},
    documentMetadata: [],
    activeNotes: [],
    notes: [],
    loading: true,
    locked: false
};
const reducer = createReducer(InitialState, (builder)=>{
    builder.addCase(logout.type, ()=>({
            ...InitialState
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState
        }));
    builder.addCase(CaseDocumentsActions.loadDocuments.fulfilled, (state)=>{
        return {
            ...state,
            loading: false
        };
    });
    builder.addCase(UIActions.parentDidNavigate.type, (state, action)=>{
        return {
            ...state,
            locked: !action.payload
        };
    });
    builder.addCase(CaseDocumentsActions.fetchDocument.pending, (state)=>{
        return {
            ...state,
            feedback: null
        };
    });
    builder.addCase(UIActions.dismissFeedback, (state)=>{
        return {
            ...state,
            feedback: null
        };
    });
    builder.addCase(CaseDocumentsActions.fetchDocument.rejected, (state, action)=>{
        const error = action.error;
        return {
            ...state,
            feedback: {
                message: error.message,
                className: 'error',
                id: Math.round(Math.random() * 1000000),
                dismissable: true,
                meta: {
                    level: 'ERROR'
                }
            }
        };
    });
    builder.addCase(CaseDocumentsActions.fetchDocument.fulfilled, (state, action)=>{
        const { note: original, metadata } = action.payload;
        const note = {};
        note.content = original.Note;
        note.description = metadata.documentDescription;
        note.document_id = metadata.documentId;
        note.id = metadata.documentId;
        note.filename = metadata.documentName;
        note.filetype = metadata.mimeType;
        note.type = metadata.mimeType;
        const activeNotes = decorateNotes([
            note
        ]);
        return {
            ...state,
            activeNotes
        };
    });
    builder.addCase(CaseDocumentsActions.docMetadataAvailable, (state, action)=>{
        return {
            ...state,
            documentMetadata: action.payload
        };
    });
    builder.addCase(CaseDocumentsActions.caseDetailAvailable, (state, action)=>{
        const { caseDetail, activeProcess } = action.payload;
        return {
            ...state,
            activeCase: caseDetail,
            activeCaseRun: activeProcess
        };
    });
    builder.addCase(setActiveProcess, (state, action)=>{
        return {
            ...state,
            activeCaseRun: action.payload
        };
    });
    builder.addDefaultCase((state)=>({
            ...state
        }));
});
export default reducer;
